<template>
  <VMultiModal :showing="showing && !!folderId">
    <EditorDeckModalsLocalOrServerChoice
      v-if="activeDialog === AddVideoSteps.CHOOSE_SOURCE"
      :key="AddVideoSteps.CHOOSE_SOURCE"
      showing
      :company-id="deck.company_id"
      :folder-id="folderId"
      :max-resolution="[4096, 4096]"
      file-type="video"
      mime-type="video/mp4, video/m4v, video/mov"
      @close="close"
      @choose-file="(chooseFiles($event), refreshKey++)"
      @goto:shelf="activeDialog = AddVideoSteps.USE_SHELF"
    >
      <template #message>
        <VMessage show banner-type="warning" hide-dismiss>
          <p class="_mb-0 _font-medium">Video slides are not supported in VRIFY Meetings</p>
        </VMessage>
      </template>
    </EditorDeckModalsLocalOrServerChoice>
    <EditorDeckModalsShelfSelector
      v-show="activeDialog === AddVideoSteps.USE_SHELF"
      :key="`${refreshKey}-${AddVideoSteps.USE_SHELF}`"
      showing
      type="videos"
      :folder-id="folderId"
      :current-file="state.file"
      :company-id="deck.company_id"
      file-type="video"
      mime-type="video/mp4, video/m4v, video/mov"
      @choose-file="chooseFiles($event)"
      @close="close"
      @back="activeDialog = AddVideoSteps.CHOOSE_SOURCE"
    />
  </VMultiModal>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { reactive, ref, toRef, watch } from 'vue'

import type { Deck, IncludeCompany } from '@/entities/deck'
import type { ShelfFile } from '@/entities/shelfFile'
import type { EditDeck } from '@/composables/useEditDeck'

enum AddVideoSteps {
  CHOOSE_SOURCE,
  USE_SHELF,
}

const props = defineProps({
  showing: {
    type: Boolean,
    required: true,
  },
  deck: {
    type: Object as PropType<DeepReadonly<EditDeck>>,
    required: true,
  },
  folderId: {
    type: Number,
    default: null,
  },
})

const emit = defineEmits(['update:showing', 'add-slide'])

const initialState = { file: null as ShelfFile | null }
const activeDialog = ref<AddVideoSteps>(AddVideoSteps.CHOOSE_SOURCE)
const state = reactive({ ...initialState })

// so we can clear the ShelfSelector state when a new image is uploaded
const refreshKey = ref(0)

watch(toRef(props, 'showing'), async showing => {
  if (showing) {
    activeDialog.value = AddVideoSteps.CHOOSE_SOURCE
    Object.assign(state, initialState)
  }
})

function chooseFiles(file: ShelfFile) {
  state.file = file
  submit()
}

async function submit() {
  if (!state.file) return

  emit('add-slide', {
    type: 'V',
    deck_id: props.deck.id,
    file_id: state.file.id,
    title: state.file.name,
    description: null,
  })

  close()
}

function close() {
  state.file = null
  emit('update:showing', false)
}
</script>
